import { render, staticRenderFns } from "./EditTip.vue?vue&type=template&id=ea95b2b0&scoped=true"
import script from "./EditTip.vue?vue&type=script&lang=js"
export * from "./EditTip.vue?vue&type=script&lang=js"
import style0 from "./EditTip.vue?vue&type=style&index=0&id=ea95b2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea95b2b0",
  null
  
)

export default component.exports